/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import PrimaryStepper from "../../../../components/_utils/CommonSteppers/PrimaryStepper";
import SVGComponent from "../../../../components/_utils/SVGComponent";
import TaxAccoountStepPAN from "../../../../components/Accounts/TaxAccount/TaxAccountCreate/TaxAccoountStepPAN";
import TaxAccountStepBank from "../../../../components/Accounts/TaxAccount/TaxAccountCreate/TaxAccountStepBank";
import TaxAccountStepConfirm from "../../../../components/Accounts/TaxAccount/TaxAccountCreate/TaxAccountStepConfirm";
import TaxAccountStepContact from "../../../../components/Accounts/TaxAccount/TaxAccountCreate/TaxAccountStepContact";
import TaxAccountStepTaxType from "../../../../components/Accounts/TaxAccount/TaxAccountCreate/TaxAccountStepTaxType";
import { useGstVerification } from "../../../../components/verification/hooks/useGstVerification";
import {
  createTaxCompliantAccount,
  getTaxSections,
  resetCreateTaxCompliant,
} from "../../../../redux/features/accounts/taxAccount/taxAccountCreateEdit";
import {
  beneBankLookUp,
  beneCategories,
  beneVerifyThisBank,
  resetBankError,
  resetBeneBankData,
  resetBeneVerifyThisGst,
} from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import {
  beneLookUp,
  resetBeneData,
  resetPANVerification,
} from "../../../../redux/features/verifyPAN/verifyPAN";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";

const generateAccountName = ({ taxType, sectionCode }) => {
  if (!taxType) return "";

  const monthYear = new Date()
    .toLocaleString("en-US", { month: "short", year: "numeric" })
    .replace(" ", "")
    .toUpperCase();

  const formattedTax = taxType.replace(/\s+/g, "").toUpperCase();

  if (sectionCode) {
    const formattedSection = sectionCode
      .replace(/\s+\(/g, "(")
      .replace(/\s+/g, "_")
      .toUpperCase();

    return `${formattedTax}_${formattedSection}_${monthYear}`;
  }
  return `${formattedTax}_${monthYear}`;
};

const id = (x) => x;
const PAN_REGEX = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
const GST_REGEX = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
const IFSC_REGEX = /^[A-Z]{4}0[A-Z0-9]{6}$/;

const TaxationAccountCreate = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const scrollIt = useRef(null);
  const bankVerificationTriggered = useRef(false);
  const [remPan, setRemPan] = useState("");
  const [labels, setLabels] = useState([]);
  const [remIFSC, setRemIFSC] = useState("");
  const [activeStep, setActiveStep] = useState(0);
  const [isActive, setIsActive] = useState(false);
  const [direction, setDirection] = useState(null);
  const [remAccount, setRemAccount] = useState("");
  const [lookupNext, setLookupNext] = useState(false);
  const [activeType, setActiveType] = useState("pan");
  const [validEmail, setValidEmail] = useState(false);
  const [labelPopup, setLabelPopup] = useState(false);
  const [customErrors, setCustomErrors] = useState({});
  const [bankUserInfo, setBankUserInfo] = useState([]);
  const [verifiedPan, setVerifiedPan] = useState(null);
  const [searchPanText, setSearchPanText] = useState("");
  const [isAlertPopup, setIsAlertPopUp] = useState(false);
  const [validContact, setValidContact] = useState(false);
  const [tempRecipients, setTempRecipients] = useState([]);
  const [hideBankBlock, setBankHideBlock] = useState(false);
  const [isNextDisabled, setIsNextDisabled] = useState(true);
  const [bankAccountName, setBankAccountName] = useState("");
  const [createRecipient, setCreateRecipient] = useState([]);
  const [createDisabled, setCreateDisabled] = useState(false);
  const [showModalPopup, setShowModalPopup] = useState(false);
  const [bankLookupNext, setBankLookupNext] = useState(false);
  const [removeClassName, setRemoveClassName] = useState(true);
  const [selectedTaxType, setSelectedTaxType] = useState(null);
  const [pendingNavTarget, setPendingNavTarget] = useState(null);
  const [selectedValue, setSelectedValue] = useState("legalname");
  const [originalRecipients, setOriginalRecipients] = useState([]);
  const [labelPopupLoading, setLabelPopupLoading] = useState(false);
  const [selectedLabelsCreate, setSelectedLabelsCreate] = useState([]);
  const [accountNameValidation, setAccountNameValidation] = useState(true);
  const [showAdditionalSection, setShowAdditionalSection] = useState(false);
  const [showAdditionalRecipient, setShowAdditionalRecipient] = useState([]);
  const [recipientButtonDisabled, setRecipientButtonDisabled] = useState(true);
  const [additionalChip, setAdditionalChip] = useState(showAdditionalRecipient);
  const [contactDetails, setContactDetails] = useState({
    email: "",
    contact: "",
    accountname: "",
  });
  const [payload, setPayload] = useState({
    bank_account: "",
    ifsc_code: "",
    contact_no: "",
    email_id: "",
    gstin: "",
    name: "",
    category: "",
    type_of_account: "",
    tax_section_id: 0,
    panNumber: "",
    gst_org_name: "",
    account_name: "",
    labels: [],
    recipient_email: "",
    userName: "",
    selectedTaxType: "",
    userId: "",
    account_name_generated: "",
  });
  const animationClass =
    direction === "next" ? "animate-slide-next" : "animate-slide-prev";

  const steps = [
    "PAN details",
    "Bank details",
    "Tax type,labels and recipients",
    "Contact details",
    "Confirm and create",
  ];

  const commonStepperConfig = {
    previousEnableBgColor: "var(--primary-nav-act)",
    previousDisableBgColor: "var(--text-disabled)",
    previousEnableTextColor: "var(--text-primary)",
    previousHoverOption: "white",
    nextEnableBgColor: "var(--text-primary)",
    nextDisableBgColor: "var(--text-disabled)",
    nextEnableTextColor: "var(--primary-bg)",
    nextDisableTextColor: "var(--text-primary)",
    nextHoverOption: "black",
  };

  const dataArray = steps.map((stepLabel, index) => {
    const isLastStep = index === steps.length - 1;
    const isTaxAccountLoading = isLastStep && createDisabled;
    return {
      ...commonStepperConfig,
      previousText: index === 0 ? "Cancel" : "Previous",
      previousIsDisabled: isTaxAccountLoading,
      nextText: isLastStep ? "Create" : "Next",
      nextLoaderNeeded: isLastStep,
      nextIsLoading: isTaxAccountLoading,
      nextIsEnabled: isLastStep ? !createDisabled : !isNextDisabled,
      nextEnableBgColor: isLastStep
        ? "var(--positive-act)"
        : "var(--text-primary)",
      nextDisableBgColor: isLastStep
        ? "var(--positive-act)"
        : "var(--text-disabled)",
      nextEnableTextColor: isLastStep
        ? "var(--text-primary)"
        : "var(--primary-bg)",
      nextDisableTextColor: isLastStep
        ? "var(--text-primary)"
        : "var(--text-primary)",
      stepperText: stepLabel,
    };
  });

  const { services, isLoading } = useSelector((state) => state.refreshToken);
  const {
    verifyPAN,
    beneLookData,
    beneLookLoading,
    verifyPANisLoading,
    beneLookError,
  } = useSelector((state) => state.verify);

  const { verifyBank, verifyBankisLoading } = useSelector(
    (state) => state.beneAllVerification,
  );
  const benebankLookData = useSelector(
    (state) => state.beneAllVerification.beneLookData,
  );

  const isBankError = useSelector(
    (state) => state.beneAllVerification.isBankError,
  );
  const bankStatus = useSelector(
    (state) => state.beneAllVerification.verifyBank,
  );
  const bankData = useSelector(
    (state) => state.beneAllVerification.beneLookData,
  );
  const taxCategories = useSelector(
    (state) => state.beneAllVerification.beneTransCategories.categories,
  ).filter((cat) => cat?.active === "Y");

  const { taxSectionData } = useSelector((state) => state.taxCompliantAccounts);

  const { createTaxCompliantLoading } = useSelector(
    (state) => state.taxCompliantAccounts,
  );
  const gstHook = useGstVerification(payload.gstin, payload.panNumber);

  const generatedAccountName = useMemo(() => {
    if (!payload.tax_type_label) return "";

    return generateAccountName({
      taxType: payload.tax_type_label,
      sectionCode:
        payload.type_of_account?.toLowerCase() === "tds"
          ? payload.sectionCode
          : "",
    });
  }, [payload.tax_type_label, payload.sectionCode, payload.type_of_account]);

  const SECTION_OPTIONS = useMemo(() => {
    if (!taxSectionData) return [];

    return taxSectionData
      .filter((item) => item.active === true)
      .map((item) => ({
        id: item.id,
        name: `${item.section_name} (${item.code})`,
        section_name: item.section_name,
        code: item.code,
        description: item.description,
      }));
  }, [taxSectionData]);

  const SECTION_META = useMemo(() => {
    if (!taxSectionData) return {};

    return taxSectionData.reduce((acc, item) => {
      const key = `${item.section_name} (${item.code})`.toLowerCase();

      acc[key] = {
        description: item.description,
      };

      return acc;
    }, {});
  }, [taxSectionData]);

  const ALLOWED_TAX_TYPES = ["income_tax", "tds", "gst", "pt"];
  const normalize = (str = "") => str.toLowerCase().replace(/\s+/g, "_");

  const TAX_OPTIONS =
    taxCategories
      ?.filter(
        (cat) => cat?.name && ALLOWED_TAX_TYPES.includes(normalize(cat.name)),
      )
      ?.map((cat) => ({
        name: cat.name,
        description: cat.description || "",
      })) || [];

  const TAX_META =
    taxCategories?.reduce((acc, cat) => {
      const key = normalize(cat.name);

      if (ALLOWED_TAX_TYPES.includes(key)) {
        acc[key] = {
          description: cat.description || "",
        };
      }

      return acc;
    }, {}) || {};

  const resolveTaxIcon = (label = "", meta, item) => {
    const key = item?.name?.toLowerCase();

    switch (key) {
      case "income_tax":
        return ICONS.INCOME_TAX;
      case "tds":
        return ICONS.TDS;
      case "gst":
        return ICONS.GST;
      case "pt":
        return ICONS.PROFESSIONAL_TAX;
      default:
        return ICONS?.DEFAULT_CATEGORY;
    }
  };

  const formatTaxLabel = (value = "") => {
    const key = value.toLowerCase();

    switch (key) {
      case "income_tax":
        return "Income Tax";
      case "tds":
        return "TDS";
      case "gst":
        return "GST";
      case "pt":
        return "PT";
      default:
        return value;
    }
  };

  useEffect(() => {
    if (!generatedAccountName) return;

    setPayload((prev) => ({
      ...prev,
      account_name_generated: generatedAccountName,
      account_name:
        selectedValue === "legalname"
          ? generatedAccountName
          : prev.account_name,
    }));
  }, [generatedAccountName, selectedValue]);

  const dataReceiveFromContact = (data) => {
    setContactDetails(data);
  };

  useEffect(() => {}, [dispatch]);

  const handleOpen = () => {
    setRemPan(payload.panNumber);
    setShowModalPopup(true);
  };

  const handleCreateAccount = async () => {
    try {
      setCreateDisabled(createTaxCompliantLoading);
      const apiPayload = {
        bank_account_no: payload.bank_account,
        contact_no: payload.contact_no,
        email: payload.email_id,
        gstin: payload.gstin,
        ifsc: payload.ifsc_code,
        pan: payload.panNumber,
        name: payload.account_name,
        labels: payload.labels,
        type_of_account: payload.type_of_account,
        category: payload.category,
        recipient_email: payload.recipient_email,
      };
      if (payload.type_of_account?.toLowerCase() === "tds") {
        apiPayload.tax_section_id = payload.tax_section_id;
      }
      const data = await dispatch(
        createTaxCompliantAccount({
          tds_accounts: apiPayload,
          navigate,
        }),
      ).unwrap();

      const accountId = data?.tds_accounts?.[0]?.id;
      dispatch(resetCreateTaxCompliant());
      if (accountId) {
        navigate(
          `/tax_account_dashboard/create_tax_account/success/${accountId}`,
        );
      }
    } catch (error) {
      navigate("/tax_account_dashboard/create_tax_account/failed", {
        state: error,
      });
    } finally {
      setCreateDisabled(false);
    }
  };

  let haveApproved = beneLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "approved";
  });

  let havePending = beneLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "pending";
  });
  let haveBankApproved = bankData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "approved";
  });

  let haveBankPending = bankData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "pending";
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleMainCreate = () => {
    if (benebankLookData?.status === undefined && beneLookError === true) {
      handleCreateAccount();
      sessionStorage.setItem("Create Tax Fresh PAN", false);
      sessionStorage.setItem("Create Tax Fresh Bank", false);
      sessionStorage.removeItem("Create Tax Approve and Decline status");
    } else if (
      !haveApproved &&
      !havePending &&
      !haveBankApproved &&
      !haveBankPending
    ) {
      handleCreateAccount();
      sessionStorage.setItem("Create Tax Fresh PAN", false);
      sessionStorage.setItem("Create Tax Fresh Bank", false);
      sessionStorage.removeItem("Create Tax Approve and Decline status");
    } else {
      handleOpen();
      sessionStorage.removeItem("Create Tax Approve and Decline status");
    }
  };

  const isPanVerified = verifiedPan === true;
  const isIFSCValid =
    payload?.ifsc_code?.length === GlobalConfiguration?.ifscLength &&
    IFSC_REGEX.test(payload?.ifsc_code);

  const isGstEmpty =
    payload.gstin.length === GlobalConfiguration?.lengthCheckZero;

  const isGstVerified =
    payload.gstin.length === GlobalConfiguration?.gstLength &&
    gstHook?.GSTStatus === true;

  const isGstFormatValid =
    payload.gstin.length === GlobalConfiguration?.gstLength &&
    GST_REGEX.test(payload.gstin);

  const isGstValid = isGstEmpty || (isGstFormatValid && isGstVerified);

  const isGstInvalid = payload.gstin.length > 0 && !isGstValid;
  const isPanStepValid =
    payload.panNumber.length === 10 &&
    isPanVerified &&
    isGstValid &&
    !isGstInvalid &&
    (beneLookData === null ? true : lookupNext === true && !isGstInvalid);

  const isBankAccountFilled =
    payload.bank_account?.length >= GlobalConfiguration?.accountnormalLength;

  const isIfscValid =
    payload.ifsc_code?.length === GlobalConfiguration?.ifscLength;

  const isBankDetailsFilled = isBankAccountFilled && isIfscValid;

  const isBankVerificationSuccessful = verifyBank?.status === true;

  const hasBankVerificationError = isBankError || verifyBank?.status === false;

  const isDuplicateBankAccount = benebankLookData?.beneficiary_accounts?.some(
    (account) =>
      account.bank_acc_no === payload.bank_account &&
      account.ifsc_code === payload.ifsc_code &&
      account.pan_no === payload.panNumber,
  );

  const isBankStepValid =
    isBankDetailsFilled &&
    isBankVerificationSuccessful &&
    !hasBankVerificationError &&
    !isDuplicateBankAccount;

  const isTaxTypeSelected = Boolean(payload?.type_of_account);

  const isTdsAccount = payload?.type_of_account?.toLowerCase() === "tds";

  const isSectionSelected = Boolean(payload?.sectionCode);

  const isTaxTypeStepValid = isTdsAccount
    ? isTaxTypeSelected && isSectionSelected
    : isTaxTypeSelected;

  const isContactNumberValid = contactDetails.contact === true;
  const isEmailAddressValid = contactDetails.email === true;
  const isAccountNameValid = contactDetails.accountname === true;

  const isAccountNameFilled =
    payload.account_name &&
    payload.account_name.trim().length > GlobalConfiguration?.lengthCheckZero;

  const isContactStepValid =
    isContactNumberValid &&
    isEmailAddressValid &&
    isAccountNameValid &&
    isAccountNameFilled;

  useEffect(() => {
    if (beneLookLoading || verifyPANisLoading || verifyBankisLoading) {
      setIsNextDisabled(true);
      return;
    }

    let isNextEnabled = false;

    switch (activeStep) {
      case GlobalConfiguration.lengthCheckZero:
        isNextEnabled = isPanStepValid;
        break;

      case GlobalConfiguration.lengthCheckOne:
        isNextEnabled = isBankStepValid;
        break;

      case GlobalConfiguration.lengthCheckTwo:
        isNextEnabled = isTaxTypeStepValid;
        break;

      case GlobalConfiguration.lengthCheckThree:
        isNextEnabled = isContactStepValid;
        break;

      case GlobalConfiguration.lengthCheckFour:
      case GlobalConfiguration.lengthCheckFive:
        isNextEnabled = true;
        break;

      default:
        isNextEnabled = false;
    }

    setIsNextDisabled(!isNextEnabled);
  }, [
    activeStep,
    verifiedPan,
    payload?.gstin,
    payload?.bank_account,
    payload?.ifsc_code,
    payload?.type_of_account,
    payload?.sectionCode,
    verifyBank?.status,
    contactDetails?.contact,
    contactDetails?.email,
    contactDetails?.accountname,
    beneLookData,
    lookupNext,
    beneLookLoading,
    isTaxTypeStepValid,
    isDuplicateBankAccount,
    benebankLookData,
    gstHook.GSTStatus,
  ]);

  const handleKeyDown = useCallback(
    (e) => {
      if (e.target.tagName === "INPUT") return;

      if (
        e.key === "Enter" &&
        activeStep === GlobalConfiguration?.lengthCheckThree
      ) {
        handleMainCreate();
      }

      if (e.code === "Space") {
        setShowModalPopup(false);
      }

      const blockedKeys = ["ArrowLeft", "ArrowRight", "Tab", " "];

      if (blockedKeys.includes(e.key)) {
        e.preventDefault();
      }
    },
    [activeStep, handleMainCreate],
  );

  const handleNext = () => {
    if (
      activeStep === GlobalConfiguration?.lengthCheckThree &&
      !isTaxTypeSelected
    ) {
      return;
    }
    if (activeStep === GlobalConfiguration?.lengthCheckFour) {
      handleMainCreate();
      return;
    }
    setActiveStep(
      (prevActiveStep) => prevActiveStep + GlobalConfiguration?.lengthCheckOne,
    );
    setDirection("next");
    setRemoveClassName(false);

    setTimeout(() => {
      setRemoveClassName(true);
    }, 1000);
  };

  const handleBack = () => {
    if (activeStep === GlobalConfiguration?.lengthCheckZero) {
      navigate(-1);
      return;
    }
    setActiveStep(
      (prevActiveStep) => prevActiveStep - GlobalConfiguration?.lengthCheckOne,
    );
    setDirection("previous");
    setRemoveClassName(false);
    setTimeout(() => {
      setRemoveClassName(true);
    }, 1000);
  };

  const handlePanChange = (e) => {
    let inputPan = e.target.value.toUpperCase();
    inputPan = inputPan.replace(/[^A-Z0-9]/g, "");

    if (inputPan.length > 10) return;

    setVerifiedPan(null);
    setLookupNext(false);
    dispatch(resetBeneData());
    dispatch(resetPANVerification());

    if (inputPan.length === 10) {
      if (!PAN_REGEX.test(inputPan)) {
        setVerifiedPan(false);
      }
    }
    setPayload({
      ...payload,
      panNumber: inputPan,
      gstin: "",
    });
    setIsActive(false);
    dispatch(resetBeneVerifyThisGst());
  };

  const accountHome = () => {
    navigate("/tax_account_dashboard");
  };

  const renderCreateAccount = () => {
    switch (activeStep) {
      case 0:
        return (
          <TaxAccoountStepPAN
            handlePanChange={handlePanChange}
            // handleGSTChange={handleGSTChange}
            payload={payload}
            setPayload={setPayload}
            verifiedPan={verifiedPan}
            verifyPANisLoading={verifyPANisLoading}
            lookupNext={lookupNext}
            setLookupNext={setLookupNext}
            panDetails={verifyPAN?.pan_details}
            beneLookData={beneLookData}
            beneLookLoading={beneLookLoading}
            setIsArchived={id}
            setIsApproved={id}
            setIsDennied={id}
            setIsPending={id}
            setAccountType={(e) => {}}
            setIsActive={setIsActive}
            isActive={isActive}
            setHideBlock={id}
            setNonArchive={id}
            setShowAccInfo={id}
          />
        );
      case 1:
        return (
          <TaxAccountStepBank
            payload={payload}
            setPayload={setPayload}
            setIsNextDisabled={setIsNextDisabled}
            activeStep={activeStep}
            bankLookupNext={bankLookupNext}
            setBankLookupNext={setBankLookupNext}
            isIFSCValid={isIFSCValid}
            isBankError={isBankError}
            verifiedPan={verifiedPan}
            previousId={id}
            hideBankBlock={hideBankBlock}
            setBankUserInfo={setBankUserInfo}
            setShowAccInfo={id}
            setBankIsArchived={id}
            setBankIsApproved={id}
            setBankIsDennied={id}
            setBankIsPending={id}
            setBankAccountType={(e) => {}}
            setActive={id}
            setBankHideBlock={setBankHideBlock}
            verifyBankisLoading={verifyBankisLoading}
          />
        );
      case 2:
        return (
          <TaxAccountStepTaxType
            selectedTaxType={selectedTaxType}
            setSelectedTaxType={setSelectedTaxType}
            payload={payload}
            setPayload={setPayload}
            selectedLabelsCreate={selectedLabelsCreate}
            setSelectedLabelsCreate={setSelectedLabelsCreate}
            createRecipient={createRecipient}
            setCreateRecipient={setCreateRecipient}
            taxOptions={TAX_OPTIONS}
            taxMeta={TAX_META}
            sectionOptions={SECTION_OPTIONS}
            sectionMeta={SECTION_META}
            resolveTaxIcon={resolveTaxIcon}
            formatTaxLabel={formatTaxLabel}
            labels={labels}
            setLabels={setLabels}
            labelPopup={labelPopup}
            setLabelPopup={setLabelPopup}
            tempRecipients={tempRecipients}
            setTempRecipients={setTempRecipients}
            originalRecipients={originalRecipients}
            setOriginalRecipients={setOriginalRecipients}
            showAdditionalSection={showAdditionalSection}
            setShowAdditionalSection={setShowAdditionalSection}
            labelPopupLoading={labelPopupLoading}
            setLabelPopupLoading={setLabelPopupLoading}
            showAdditionalRecipient={showAdditionalRecipient}
            setShowAdditionalRecipient={setShowAdditionalRecipient}
            recipientButtonDisabled={recipientButtonDisabled}
            setRecipientButtonDisabled={setRecipientButtonDisabled}
            additionalChip={additionalChip}
            setAdditionalChip={setAdditionalChip}
          />
        );
      case 3:
        return (
          <TaxAccountStepContact
            payload={payload}
            setPayload={setPayload}
            parentCreateBen={dataReceiveFromContact}
            activeStep={activeStep}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            validEmail={validEmail}
            setValidEmail={setValidEmail}
            customErrors={customErrors}
            setCustomErrors={setCustomErrors}
            validContact={validContact}
            setValidContact={setValidContact}
            accountNameValidation={accountNameValidation}
            setAccountNameValidation={setAccountNameValidation}
          />
        );
      case 4:
        return (
          <TaxAccountStepConfirm
            payload={payload}
            bankAccountName={bankAccountName}
            setShowModalPopup={setShowModalPopup}
            showModalPopup={showModalPopup}
            bankUserInfo={bankUserInfo}
            recipients={createRecipient}
            selectedTaxType={selectedTaxType}
            sectionCode={payload.sectionCode}
            taxMeta={TAX_META}
            sectionMeta={SECTION_META}
            resolveTaxIcon={resolveTaxIcon}
            activeType={activeType}
            setActiveType={setActiveType}
            setRemPan={setRemPan}
            setRemAccount={setRemAccount}
            setRemIFSC={setRemIFSC}
            remIFSC={remIFSC}
            remAccount={remAccount}
            remPan={remPan}
            setSearchPanText={setSearchPanText}
            searchPanText={searchPanText}
            createDisabled={createDisabled}
            handlefunction={handleCreateAccount}
            pendingNavTarget={pendingNavTarget}
            setPendingNavTarget={setPendingNavTarget}
            isAlertPopup={isAlertPopup}
            setIsAlertPopUp={setIsAlertPopUp}
            formatTaxLabel={formatTaxLabel}
          />
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);

  useEffect(() => {
    if (payload.panNumber.length !== GlobalConfiguration?.gstLength) {
      setVerifiedPan(null);
    }
  }, [payload.panNumber]);

  useEffect(() => {
    dispatch(resetPANVerification());
    setVerifiedPan(null);
  }, []);

  useEffect(() => {
    if (verifyPANisLoading) return;
    if (!payload.panNumber) {
      setVerifiedPan(null);
      return;
    }

    if (verifyPAN?.status) {
      setVerifiedPan(true);
      dispatch(beneLookUp({ pan_number: payload.panNumber }));
      setPayload((prev) => ({
        ...prev,
        legalName: verifyPAN?.pan_details?.full_name,
      }));
    } else if (
      verifyPAN?.status === false &&
      payload?.panNumber.length === GlobalConfiguration.panLength
    ) {
      setVerifiedPan(false);
    }
  }, [verifyPAN, verifyPANisLoading, payload.panNumber]);

  useEffect(() => {
    if (!verifyBankisLoading && verifyBank?.status) {
      setBankAccountName(
        verifyBank?.verification_details?.[0]?.full_name || "",
      );
    }
  }, [verifyBank, verifyBankisLoading]);

  useEffect(() => {
    if (!payload.bank_account || !payload.ifsc_code) {
      dispatch(resetBeneBankData());
      dispatch(resetBankError());
      setBankLookupNext(false);
    }
  }, [payload?.bank_account, payload?.ifsc_code]);

  useEffect(() => {
    if (payload.ifsc_code?.length < GlobalConfiguration?.ifscLength) {
      dispatch(resetBankError());
    }
    if (
      payload.bank_account?.length === GlobalConfiguration?.lengthCheckZero &&
      payload.ifsc_code
    ) {
      setPayload((prev) => ({
        ...prev,
        ifsc_code: "",
      }));
    }
  }, [payload?.bank_account, payload?.ifsc_code]);

  useEffect(() => {
    if (
      createRecipient &&
      createRecipient.length > GlobalConfiguration?.lengthCheckZero
    ) {
      setPayload((prev) => ({
        ...prev,
        recipient_email: createRecipient.join(","),
      }));
    } else {
      setPayload((prev) => {
        const updated = { ...prev };
        delete updated.recipient_email;
        return updated;
      });
    }
  }, [createRecipient]);

  useEffect(() => {
    const isValid =
      payload.bank_account?.length >=
        GlobalConfiguration?.accountnormalLength &&
      payload.ifsc_code?.length === GlobalConfiguration?.ifscLength &&
      /^[A-Z]{4}0[A-Z0-9]{6}$/.test(payload.ifsc_code);

    if (isValid && !bankVerificationTriggered.current) {
      bankVerificationTriggered.current = true;

      dispatch(
        beneVerifyThisBank({
          ifsc_code: payload.ifsc_code,
          bank_account: payload.bank_account,
          legal_name: payload.legalName,
          navigate,
        }),
      );

      dispatch(
        beneBankLookUp({
          ifsc: payload.ifsc_code,
          bank_account_no: payload.bank_account,
        }),
      );
    }

    if (!isValid) {
      bankVerificationTriggered.current = false;
    }
  }, [
    payload.bank_account,
    payload.ifsc_code,
    bankStatus?.verification_details[0].is_virtual,
    payload.legalName,
  ]);

  useEffect(() => {
    if (!isLoading && services != null) {
      if (services?.includes("BUAccount") || services?.includes("Admin")) {
      } else {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "BUAccount" },
        });
      }
    }
  }, [services, isLoading]);

  useEffect(() => {
    dispatch(getTaxSections());
  }, [dispatch]);

  useEffect(() => {
    dispatch(beneCategories());
  }, [dispatch]);

  return (
    <div className="w-width-full flex flex-col items-center h-full-height bg-primary-bg">
      <div className="w-width-full Qlg:bg-transparent bg-primary-nav">
        <div className="h-navbar-height hidden Qsmd:block"></div>
        <div className="h-[calc(var(--navbar-breadcrumb-height)-var(--navbar-height))] mb-margin-sm mt-margin-xs Qsmd:my-margin-base"></div>
      </div>

      <div className="flex justify-center items-end !bottom-bottom-base rounded-t-border-radius-md Qlg:bg-transparent bg-primary-nav rounded-b-border-radius-md w-screen fixed Qsmd:relative Qsmd:top-top-base left-left-base z-z-index-header flex-shrink-0 h-[var(--padding-bottom-unassign-cat)]">
        <PrimaryStepper
          activeStep={activeStep}
          handleForwardAction={handleNext}
          handleBackwardAction={handleBack}
          dataArray={dataArray}
        />
      </div>

      <div
        className="flex items-center w-width-full bg-primary-nav p-padding-sm h-mobile-create-header fixed left-left-base top-top-base z-z-index-header rounded-b-border-radius-md Qsmd:hidden"
        onClick={accountHome}
      >
        <SVGComponent
          color="var(--text-primary)"
          height="var(--icon-sm)"
          width="var(--icon-sm)"
          url={ICONS?.ARROW_LEFT_WHITE}
          alt="Icon"
        />
        <div className=" flex flex-col pl-padding-md gap-gap-xs">
          <p className=" text-font-md font-sans text-text-primary">
            Tax Account
          </p>
          <p className="text-xs font-sans text-text-primary">
            {steps[activeStep]}
          </p>
        </div>
      </div>

      <>
        <div
          className="overflow-x-hidden overflow-y-auto h-full flex flex-col items-center relative w-width-full"
          ref={scrollIt}
        >
          <div
            className={`w-width-full  Qsmd:pt-padding-md Qsmd:pb-padding-md pt-padding-base max-w-tab-width-normal mx-auto ${
              activeStep === GlobalConfiguration.lengthCheckZero &&
              direction === "next"
                ? ""
                : removeClassName === true
                  ? ""
                  : animationClass
            }`}
          >
            {renderCreateAccount()}
          </div>
        </div>
      </>

      <div className="h-mobile-create-header flex-shrink-0 w-width-full Qsmd:hidden block"></div>
    </div>
  );
};

export default TaxationAccountCreate;
